enum sensorType{
    GET_ALL_SENSOR_START='GET_ALL_SENSOR_START',
    GET_ALL_SENSOR_SUCCESS = 'GET_ALL_SENSOR_SUCCESS',
    GET_ALL_SENSOR_ERROR = 'GET_ALL_SENSOR_ERROR',
    DELETE_SENSOR_START='DELETE_SENSOR_START',
    DELETE_SENSOR_SUCCESS='DELETE_SENSOR_SUCCESS',
    DELETE_SENSOR_ERROR = 'DELETE_SENSOR_ERROR',
    RESET_DELETE_SENSOR_STATE = 'RESET_DELETE_SENSOR_STATE',
    ADD_SENSOR_START='ADD_SENSOR_START',
    ADD_SENSOR_SUCCESS='ADD_SENSOR_SUCCESS',
    ADD_SENSOR_ERROR='ADD_SENSOR_ERROR',
    RESET_ADD_SENSOR_STATE='RESET_ADD_SENSOR_STATE',
    GET_SENSOR_BY_ID_START='GET_SENSOR_BY_ID_START',
    GET_SENSOR_BY_ID_SUCCESS='GET_SENSOR_BY_ID_SUCCESS',
    GET_SENSOR_BY_ID_ERROR='GET_SENSOR_BY_ID_ERROR',
    GET_SENSOR_FILTER_START='GET_SENSOR_FILTER_START',
    GET_SENSOR_FILTER_SUCCESS='GET_SENSOR_FILTER_SUCCESS',
    GET_SENSOR_FILTER_ERROR='GET_SENSOR_FILTER_ERROR',
    RESET_GET_SENSOR_BY_ID_STATE='RESET_GET_SENSOR_BY_ID_STATE',
    GET_UNIQUE_BUILDING_START = 'GET_UNIQUE_BUILDING_START',
    GET_UNIQUE_BUILDING_SUCCESS = 'GET_UNIQUE_BUILDING_SUCCESS',
    GET_UNIQUE_BUILDING_ERROR = 'GET_UNIQUE_BUILDING_ERROR',
    RESET_ALL_SENSOR_STATE = 'RESET_ALL_SENSOR_STATE',
    GET_ALL_DEVICES_START='GET_ALL_DEVICES_START',
    GET_ALL_DEVICES_SUCCESS='GET_ALL_DEVICES_SUCCESS',
    GET_ALL_DEVICES_ERROR='GET_ALL_DEVICES_ERROR',
    RESET_ALL_DEVICES_STATE = 'RESET_ALL_DEVICES_STATE', 
    UPDATE_DEVICE_ACCESS_START = 'UPDATE_DEVICE_ACCESS_START',
    UPDATE_DEVICE_ACCESS_SUCCESS = 'UPDATE_DEVICE_ACCESS_SUCCESS',
    UPDATE_DEVICE_ACCESS_ERROR = 'UPDATE_DEVICE_ACCESS_ERROR',
    RESET_UPDATE_DEVICE_ACCESS_STATE = 'RESET_UPDATE_DEVICE_ACCESS_STATE',
}

export default sensorType;